import React from "react";
import { Skeleton, Col } from "antd";

const SkeletonLoader = () => {
  return (
    <>    
      <div className="flex justify-content-between align-items-center mb-2">
        <div className="flex gap-2">
          <Skeleton.Button
            active={true}
            style={{width:'140px'}}
            size={"default"}
            block={false}
          />
          <Skeleton.Button
            active={true}
            style={{width:'140px'}}
            size={"default"}
            block={false}
          />
        </div>
        <div className="flex gap-2">
          <Skeleton.Button
            active={true}
            size={"default"}
            style={{width:'30px !important'}}
            block={false}
          />
          <Skeleton.Button
            active={true}
            size={"default"}
            style={{width:'30px !important'}}
            block={false}
          />
          <Skeleton.Button
            active={true}
            style={{minWidth:'30px !important'}}
            size={"default"}
            block={false}
          />
        </div>
      </div>
      <Skeleton.Input active={true} size={'default'} block={true} className="mb-1"/>
      <Skeleton.Input active={true} size={'default'} block={true} className="mb-1"/>
      {/* <div
        className="relative border rounded"
        style={{ minHeight: "500px", position: "relative" }}
      >
        <div
          style={{
            height: "500px",
            overflowY: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
            <Skeleton.Image  active={true} style={{
              width:'300px',
              height:'300px'
            }}/>
        </div>
      </div> */}
    </>
  );
};

export default SkeletonLoader;
